import { Directive, forwardRef, Input } from '@angular/core';
import { FormControl, NG_VALIDATORS, Validator } from '@angular/forms';

import * as momentImported from 'moment';

const moment = momentImported;

// import * as _moment from 'moment';
// // tslint:disable-next-line:no-duplicate-imports
// import { default as _rollupMoment } from 'moment';
// const moment = _rollupMoment || _moment;

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[date-validator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => DateValidatorDirective),
            multi: true
        }
    ]
})
export class DateValidatorDirective implements Validator {

    @Input()
    get format(): string {
        return this._format;
    }
    set format(value: string) {
        this._format = value;
        if (this._onChange) {
            this._onChange();
        }
    }

    private _format = 'YYYY-M-D';
    private _onChange: () => void;

    validate(c: FormControl): { [key: string]: any; } {
        const err = {
            date: {
                given: c.value,
                format: this.format
            }
        };

        return moment(c.value, this.format, true).isValid() ? null : err;
    }

    registerOnValidatorChange(fn: () => void): void { this._onChange = fn; }

}
